import { useEffect, useState } from 'react'

// Auto-playing phone for the hero: cycles through real app screens.
const screens = [
  { src: '/screenshots/v2/discover.jpg', alt: 'Discover local shops', chip: 'Shops nearby' },
  { src: '/screenshots/v2/shop.jpg', alt: 'Browse a shop', chip: 'Live menu' },
  { src: '/screenshots/v2/rewards.jpg', alt: 'Your rewards', chip: 'Rewards unlocked' },
  { src: '/screenshots/v2/qr.jpg', alt: 'Your QR code', chip: 'Points in a scan' },
]

const HeroPhone = () => {
  const [i, setI] = useState(0)

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    const id = window.setInterval(() => setI((n) => (n + 1) % screens.length), 3200)
    return () => window.clearInterval(id)
  }, [])

  return (
    <div className="relative animate-float">
      <div className="relative w-[230px] sm:w-[260px] rounded-[2.4rem] border-[8px] border-gray-900 bg-gray-900 shadow-2xl overflow-hidden aspect-[720/1610]">
        {screens.map((s, n) => (
          <img
            key={s.src}
            src={s.src}
            alt={s.alt}
            loading={n === 0 ? 'eager' : 'lazy'}
            className="absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-700"
            style={{ opacity: n === i ? 1 : 0 }}
          />
        ))}
      </div>
      <div
        key={i}
        className="animate-chip-in absolute -left-6 sm:-left-14 top-1/4 bg-white rounded-full shadow-xl border border-primary-100 px-4 py-2 text-sm font-semibold text-primary-700 whitespace-nowrap"
      >
        {screens[i].chip}
      </div>
    </div>
  )
}

export default HeroPhone
